import {createElement, Component, PropTypes} from 'rlink-react';
import allCountries from 'rlink-regions/getAllSupportedCountries';

import RegionPicker from 'rlink-regions/components/RegionPicker';
import defaultTheme from 'rlink-regions/components/RegionPicker.less';

import {REGION_COOKIES} from 'rlink-regions/constants';

import getSupportedLanguages from 'rlink-regions/getSupportedLanguages';
import getPreferredLanguages from 'rlink-regions/getPreferredLanguages';
import getClosestSupportedLanguage from 'rlink-regions/getClosestSupportedLanguage';
import getUserSelectedCountry from 'rlink-regions/getUserSelectedCountry';
import getCountryFromPreferredLanguages from 'rlink-regions/getCountryFromPreferredLanguages';

import getRegionForCountry from 'rlink-regions/getRegionForCountry';

import themeable from 'rlink-theme/themeable';

import routingActions from 'rlink-router/actions';

export default class CookieRegionPicker extends Component {
  constructor (props, context) {
    super(props, context);
    let supportedLanguages = getSupportedLanguages();
    let preferredLanguages = getPreferredLanguages();
    let closestLanguage = getClosestSupportedLanguage(supportedLanguages, preferredLanguages);
    let country = getUserSelectedCountry();
    if (country === null) {
      country = getCountryFromPreferredLanguages(preferredLanguages);
    }

    this.state = {
      country: country,
      readingLanguage: closestLanguage,
      collapse: [CookieRegionPicker.collapsibles.COUNTRY_LIST],
    };
    if (props.saveImmediately) {
      this.setCookie(REGION_COOKIES.COUNTRY, country);
      this.setCookie(REGION_COOKIES.READING_LANGUAGE, closestLanguage);
    }
  }

  get countries () {
    let ratingsBoardsCountries = Object.values(this.props.ratingsBoards);
    ratingsBoardsCountries = (ratingsBoardsCountries.length > 0)
      ? ratingsBoardsCountries.reduce((a, b) => a.concat(b))
      : [];
    let countryCodes = (this.state.collapse.includes(CookieRegionPicker.collapsibles.COUNTRY_LIST))
      ? allCountries.filter(country =>
          ratingsBoardsCountries.includes(country.code)
          || this.state.country === country.code)
      : allCountries;

    return countryCodes;
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  setCookie (name, value) {
    document.cookie = `${name}=${value};path=/;expires=Wed, 02 May 2525 01:15:11 GMT`;

  }

  toggleCollapse (ev) {
    let collapse = this.state.collapse;
    if (collapse.includes(ev.collapsible)) {
      collapse.splice(collapse.indexOf(ev.collapsible), 1);
    } else {
      collapse.push(ev.collapsible);
    }

    this.setState({collapse});
  }

  updateCountry (ev) {
    this.setCookie(REGION_COOKIES.COUNTRY, ev.value);
    this.setState({country: ev.value});
    let region = getRegionForCountry(ev.value, this.props.skuGroups, this.props.regionRestrictions).toString();
    routingActions.ExternalNavTo({
      url: window.location.origin + window.location.pathname,
      params: {region}
    });
  }

  updateReadingLanguage (ev) {
    this.setCookie(REGION_COOKIES.READING_LANGUAGE, ev.value);
    this.setState({readingLanguage: ev.value});
    routingActions.NavTo({params: { locale: ev.value }, scrollTo: false});
  }


  render () {
    let supportedLanguages = getSupportedLanguages();
    return <RegionPicker readingLanguage={this.state.readingLanguage}
      togglable={this.props.togglable}
      country={this.state.country}
      mapSettings={this.props.mapSettings}
      collapse={this.state.collapse}
      onToggleCollapse={ev => this.toggleCollapse(ev)}
      fieldData={{
        flagChoice: this.state.value,
        dropdownChoice: this.state.value,
      }}
      type={this.props.type}
      countryCodes={this.countries.map(country => (country.code))}
      language={this.state.readingLanguage}
      onUpdateCountry={ev => {
        this.updateCountry(ev);
      }}
      onUpdateReadingLanguage={ev => {
        this.updateReadingLanguage(ev);
      }}
      useFlags={this.props.useFlags}
      showPlaceholder={this.props.showPlaceholder}
      sortBy={this.props.sortBy}
      languages={supportedLanguages}
      {... RegionPicker.theme(this.props)} />;
  }
}

CookieRegionPicker.sortTypes = RegionPicker.sortTypes;
CookieRegionPicker.renderTypes = RegionPicker.renderTypes;
CookieRegionPicker.collapsibles = RegionPicker.collapsibles;

CookieRegionPicker.propTypes = {
  type: PropTypes.oneOf(Object.values(RegionPicker.renderTypes)),
  mapSettings: PropTypes.object,
  skuGroups: PropTypes.object,
  regionRestrictions: PropTypes.object,
  value: PropTypes.string,
  saveImmediately: PropTypes.bool,
  useFlags: PropTypes.bool,
  showPlaceholder: PropTypes.bool,
  sortBy: PropTypes.array,
  togglable: PropTypes.bool,
  ratingsBoards: PropTypes.object,
};

CookieRegionPicker.defaultProps = {
  type: RegionPicker.renderTypes.RADIO_SELECT,
  value: '',
  saveImmediately: false,
  useFlags: false,
  showPlaceholder: false,
  sortBy: [],
  togglable: false,
  theme: defaultTheme,
};

themeable(CookieRegionPicker, {
  forwards: [
    RegionPicker,
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-regions/components/cookie/RegionPicker.jsx